import { X } from 'lucide-react';

import { Button } from '@/components/core/button';

import { AddFilterDropdown } from './add-filter-dropdown';
import { DataTableFilterItem } from './data-table-filter-item';
import { DataTableSearchInput } from './data-table-search-input';
import type { FilterDefs } from './types';
import type { FiltersInstance } from './use-filters';

type Props<TDefs extends FilterDefs> = {
  filters: FiltersInstance<TDefs>;
};

export function DataTableFilterMenu<TDefs extends FilterDefs>({
  filters: {
    filterState,
    filterDefs,
    addFilter,
    updateFilter,
    removeFilter,
    clearAll,
    search,
    updateSearch,
  },
}: Props<TDefs>) {
  return (
    <div className="flex flex-wrap items-center gap-2">
      <DataTableSearchInput value={search} onChange={updateSearch} />
      {filterState.map((filter) => {
        const filterDef = filterDefs[filter.id];

        if (!filterDef) {
          console.error(`No supported definition for filter ${filter.id}`);
          return null;
        }

        return (
          <DataTableFilterItem
            key={filter.id}
            filter={filter}
            filterDef={filterDef}
            onChange={updateFilter}
            onRemove={removeFilter}
          />
        );
      })}
      {Object.keys(filterDefs).length > 0 && (
        <AddFilterDropdown
          filterDefs={filterDefs}
          filterState={filterState}
          onSelect={addFilter}
          onRemove={removeFilter}
        />
      )}

      {(filterState.length > 0 || search.length > 0) && (
        <Button aria-label="Reset all filters" variant="outline" size="icon" onClick={clearAll}>
          <X />
        </Button>
      )}
    </div>
  );
}
